










































































































import {Vue, Component, Watch} from 'vue-property-decorator';
import TuiTree from '@/components/display/TuiTree.vue';
import {
  Mall,
  GetStandardCategoriesTreeRequest,
  GetStandardCategoriesCommissionsRequest,
  PutStandardCategoriesCommissionsRequest,
  GetStandardCategoriesExcelRequest,
} from 'supporter';
import _ from 'underscore';
import {i18nAllObject} from '@/utils/i18n';
import {writeExcel} from '@/utils/excel';
import {getDownToday} from '@/utils/dateUtils';
import {gridModelToExcel} from '@/utils/ncp';
import MallsTab from '@/components/common/MallsTab.vue';
import { getLocalStorageMalls } from '@/utils/commonUtils';

@Component({
  components: {
    TuiTree,
    MallsTab
  }
})

export default class CommissionRate extends Vue {
  private mallInfo:Mall[] = getLocalStorageMalls();
  private mallNo: number = this.initMallNo;
  // private curSelectedIdx: number = 0;
  private isShowTable: boolean = false;
  private isChildNode: boolean = false;
  private onlySelectable: boolean = true;
  private theData: any[] = [];
  private nodedata: object = {};
  private isDefaultSelected: boolean = false;
  private commissionsList: any[] = [];
  private isChanged: boolean = false;
  private categoryObj = {
    categoryPath: '',
    categoryNo: '',
    categoryName: '',
    commissionRate: '0.0',
    categoryIcon: null,
    adultCategory: true
  };

  private get initMallNo() {
    return this.mallInfo[0].mallNo;
  }

  @Watch('$route.query.mallNo')
  onMallChanged() {
    this.isChanged = false;
    this.mallNo = Number(this.$route.query.mallNo);
    this.isShowTable = false;
    this.getTreeData();
    this.getCommissions();
  }
  // private changeMall(index: number, mallNo: number): void {
  //   if (this.isChanged) {
  //     let isConfirm = confirm(this.$t('DISPLAY_COMMISSIONRATE_CHANGE_MALL_ALERT') as string);
  //     if (!isConfirm) {
  //       return;
  //     } else {
  //       this.isChanged = false;
  //     }
  //   }
  //   this.curSelectedIdx = index;
  //   this.mallNo = mallNo;
  //   this.isShowTable = false;
  //   this.getTreeData();
  //   this.getCommissions();
  // }
  private getMallName(mallNo: number): string {
    let curArr = this.mallInfo.filter((item: any) => item.mallNo === mallNo);
    return curArr[0].mallName;
  }
  private getTreeData(): void {
    const obj: GetStandardCategoriesTreeRequest = {
      params: {
        mallNo: this.mallNo + ''
      }
    };
    this.$api.getStandardCategoriesTree(obj).then((res) => {
      if (res && res.data) {
        this.theData = this.dataFormat(res.data.tree);
      }
    });
  }
  private getCommissions(): void {
    const obj: GetStandardCategoriesCommissionsRequest = {
      params: {
        mallNo: this.mallNo
      }
    };
    this.$api.getStandardCategoriesCommissions(obj).then((res) => {
      this.commissionsList = res.data;
    });
  }
  private dataFormat(data: any[]): any[] {
    let newData = data.map((item) => {
      Vue.set(item, 'text', item.name);
      Vue.set(item, 'state', 'closed');
      if (item.child) {
        Vue.set(item, 'children', item.child);
        if (item.child.length > 0) {
          this.dataFormat(item.child);
        }
      }
      return item;
    });
    return newData;
  }
  private tuiTreeSelect(template: any): void {
    this.isShowTable = true;
    this.categoryObj.categoryName = template.theObj.text;
    this.categoryObj.categoryNo = template.theObj.categoryNo + '';
    this.categoryObj.adultCategory = !template.theObj.forAdults;
    this.categoryObj.categoryIcon = template.theObj.icon;
    const parentsNameArr: string[] = [template.theObj.text];
    let categoryPathArr = (this.$refs.theTree as any).getParentsName(parentsNameArr, template.curId);
    this.categoryObj.categoryPath = categoryPathArr instanceof Array ? categoryPathArr.join('>') : categoryPathArr;
    if (template.theObj.child.length === 0) {
      this.isChildNode = true;
      let categoryObj = this.commissionsList.find((v) => v.categoryNo === template.theObj.categoryNo);
      if (categoryObj) {
        this.categoryObj.commissionRate = String(categoryObj.commissionRate).indexOf('.') == -1 ? categoryObj.commissionRate + '.0' : categoryObj.commissionRate;
      } else {
        this.categoryObj.commissionRate = '0.0';
      }
    } else {
      this.isChildNode = false;
    }
  }
  // private toMall(prevOrNext: string): void {
  //   if (prevOrNext === 'next') {
  //     if (this.curSelectedIdx === this.mallInfo.length - 1) {
  //       this.curSelectedIdx = 0;
  //     } else {
  //       this.curSelectedIdx = this.curSelectedIdx + 1;
  //     }
  //   }
  //   if (prevOrNext === 'prev') {
  //     if (this.curSelectedIdx === 0) {
  //       this.curSelectedIdx = this.mallInfo.length - 1;
  //     } else {
  //       this.curSelectedIdx = this.curSelectedIdx - 1;
  //     }
  //   }
  //   this.mallNo = this.mallInfo[this.curSelectedIdx].mallNo;
  //   this.getTreeData();
  //   this.getCommissions();
  //   this.isShowTable = false;
  // }
  private checkCommissionRate(e: any) {
    this.isChanged = true;
    let value: any = $(e.target).val();
    const pattern = /(^\d{0,2}([..]\d?){0,1}?)$/;
    let result = '';
    if (!pattern.test(value)) {
      let appearComma = false;
      for (let i = value.length - 1; i >= 0; i--) {
        if (!/^[0-9.]/.test(value[i])) {
          value = value.replace(value[i], '');
        }
        if (value[i] == '.') {
          if (appearComma) {
            value = value.replace(value[i], '');
          }
          appearComma = true;
        }
      }
      let s = value.split('.');
      result = s[0].substring(0, 2);
      if (!_.isEmpty(s[1])) {
        result += '.' + s[1].substring(0, 1);
      }
      $(e.target).val(result);
    }
  }
  private exportExcel() {
    const obj: GetStandardCategoriesExcelRequest = {
      params: {
        mallNo: Number(this.mallNo)
      }
    };
    this.$api.getStandardCategoriesExcel(obj).then((res) => {
      if (res && res.data) {
        let excelDownInfo = {
          fileName: 'standard_category_',
          columns: {
            depth1CategoryNo: 'DISPLAY_COMMISSIONRATE_CATEGORY_NO',
            depth1CategoryName: 'DISPLAY_COMMISSIONRATE_CATEGORY_DEPTH1',
            depth2CategoryNo: 'DISPLAY_COMMISSIONRATE_CATEGORY_NO',
            depth2CategoryName: 'DISPLAY_COMMISSIONRATE_CATEGORY_DEPTH2',
            depth3CategoryNo: 'DISPLAY_COMMISSIONRATE_CATEGORY_NO',
            depth3CategoryName: 'DISPLAY_COMMISSIONRATE_CATEGORY_DEPTH3',
            depth4CategoryNo: 'DISPLAY_COMMISSIONRATE_CATEGORY_NO',
            depth4CategoryName: 'DISPLAY_COMMISSIONRATE_CATEGORY_DEPTH4',
            commissionRate: 'DISPLAY_COMMISSIONRATE_CATEGORY_RATE',
          }
        };
        let formatterCols: any = [
          {
            name: 'requiresAdultCertification',
            formatter: (data: any) => {
              if (data.value) {
                return 'Y';
              }
              return 'N';
            }
          }
        ];
        let columns = i18nAllObject(this, excelDownInfo.columns);
        const model = gridModelToExcel(formatterCols);
        writeExcel(res.data, columns, excelDownInfo.fileName + '_' + getDownToday(), model.formatter);
      } else {
        alert(this.$t('COMMON_NOT_DATA'));
      }
    });
  }
  private save(): void {
    if(!this.isShowTable || !this.isChildNode) {
      window.alert(this.$t('DISPLAY_COMMISSIONRATE_NO_CONTENT'));
      return;
    }
    
    const obj: PutStandardCategoriesCommissionsRequest = {
      data: {
        mallNo: this.mallNo,
        commissionInfos: [
          {
            commissionRate: Number(this.categoryObj.commissionRate),
            categoryNo: Number(this.categoryObj.categoryNo)
          }
        ]
      }
    };

    const isConfirm = confirm(this.$t('DISPLAY_COMMISSIONRATE_ALCOHOL_CONFIRM') as string)
    if(!isConfirm) return
    this.$api.putStandardCategoriesCommissions(obj).then(() => {
      this.isShowTable = false;
      this.getTreeData();
      this.getCommissions();
    });
  }
  private mounted() {
    if(this.$route.query.mallNo){
      this.mallNo = Number(this.$route.query.mallNo);
    }
    this.getTreeData();
    this.getCommissions();
  }
}
